/**
 * Identidad legible de un subtipo. El código es la identidad estable; el nombre
 * sólo la complementa cuando existe.
 */
export function formatTypePropertyLabel(
  code: string | null | undefined,
  name: string | null | undefined
): string | null {
  const normalizedCode = code?.trim()
  if (!normalizedCode) return null

  const normalizedName = name?.trim()
  return normalizedName ? `${normalizedCode} - ${normalizedName}` : normalizedCode
}
